<template>
  <div class="breadcrumb-section">
    <div class="page-title d-flex">
      <router-link :to="{ path: '/shop' }"><h3 class="text-capitalize">{{ title }}</h3></router-link>
      <h3 class="text-capitalize ml-2" v-if="subTitle"> / {{ subTitle }}</h3>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'subTitle']
}
</script>